import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';
import SelectorForm from './SelectorForm';
import useSettingForm from './useSettingForm';

const defaultProps = {
  options: [],
  tooltip: null,
};

const SettingSelectorForm = (p) => {
  const {
    label,
    options,
    attributeNameToSave,
    tooltip,
  } = { ...defaultProps, ...filterUndefined(p) };
  const {
    loading,
    value,
    handleOnChange,
    handleOnClick,
  } = useSettingForm(label);

  return (
    <SelectorForm
      label={label}
      options={options}
      tooltip={tooltip}
      loading={loading}
      value={value}
      handleOnChange={handleOnChange}
      dataTest={attributeNameToSave}
      handleOnClick={() => {
        handleOnClick({
          [attributeNameToSave]: value,
        });
      }}
    />
  );
};

export default SettingSelectorForm;
